// Generic surface card with an optional header (title + right-aligned action).
const Card = ({ title, action, children, className = "", bodyClass = "" }) => (
  <section className={`lc-card ${className}`}>
    {(title || action) && (
      <header className="lc-card-head">
        {title && <h2 className="lc-card-title">{title}</h2>}
        {action && <div className="lc-card-action">{action}</div>}
      </header>
    )}
    <div className={`lc-card-body ${bodyClass}`}>{children}</div>
  </section>
);

export default Card;
